import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, ShoppingCart, Package } from 'lucide-react';
import './LayoutPDV.css';

const LayoutPDV = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/pdv/login');
  };

  return (
    <div className="layout-pdv">
      <header className="header-pdv">
        <div className="header-left">
          <ShoppingCart size={24} />
          <h1>PDV - Frente de Caixa</h1>
        </div>
        <div className="header-right">
          <div className="user-info">
            <span>Operador: {user?.nome || 'Usuário'}</span>
          </div>
          <button onClick={handleLogout} className="btn-logout-pdv">
            <LogOut size={18} />
            Sair
          </button>
        </div>
      </header>

      <nav className="nav-pdv">
        <button 
          onClick={() => navigate('/pdv')}
          className="nav-item-pdv active"
        >
          <ShoppingCart size={20} />
          Caixa
        </button>
        <button 
          onClick={() => navigate('/pdv/pedidos')}
          className="nav-item-pdv"
        >
          <Package size={20} />
          Pedidos
        </button>
      </nav>

      <main className="main-pdv">
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutPDV;
















